import { render, staticRenderFns } from "./OrganizationProfileTabs.vue?vue&type=template&id=2204d21a&scoped=true&"
import script from "./OrganizationProfileTabs.vue?vue&type=script&lang=js&"
export * from "./OrganizationProfileTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2204d21a",
  null
  
)

export default component.exports